import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=3db2b387&"
import script from "./InfoBlock.vue?vue&type=script&lang=js&"
export * from "./InfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=3db2b387&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports